<h2 data-testid="SUBSYS5_PUBLISHEDPROGRESS_TITLE_TXT" class="text-uppercase mb-5">
	{{ labels().PUBLISHED_PROGRESS_COMPONENT_TITLE }}
</h2>
@for (item of items(); track $index) {
<div class="d-flex my-3">
	<span><b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_FRAMEID }}:</b> {{ item.frameID }}</span>
	<span class="ms-5"><b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_PLANID }}:</b> {{ item.caseNumber }}</span>
</div>
<div class="d-flex justify-content-between my-3">
	<span>
		<b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_SURGERY_DATE }}:</b>
		{{ item.surgeryDate | convertDate:false }}
	</span>
	<span>
		<b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_REMOVAL_DATE }}:</b>
		{{ item.consolidationDate | convertDate:false }}
	</span>
</div>
@if (!item.completed) {
<ngb-progressbar-stacked>
	@if (item.init) {
	<ngb-progressbar class="progress-start" [value]="item.init" [max]="MAX">
	</ngb-progressbar>
	}
	@if (item.latency) {
	<ngb-progressbar type="primary" [value]="item.latency" [max]="MAX"
		[title]="labels().PUBLISHED_PROGRESS_COMPONENT_LATENCY">
		{{ item.latencyDays }} {{ labels().PUBLISHED_PROGRESS_COMPONENT_DAYS }}
	</ngb-progressbar>
	}
	@if (item.correction) {
	<ngb-progressbar type="warning" [value]="item.correction" [max]="MAX"
		[title]="labels().PUBLISHED_PROGRESS_COMPONENT_CORRECTION">
		{{ item.treatmentDays }} {{ labels().PUBLISHED_PROGRESS_COMPONENT_DAYS }}
	</ngb-progressbar>
	}
	@if (item.consolidation) {
	<ngb-progressbar type="success" [value]="item.consolidation" [max]="MAX"
		[title]="labels().PUBLISHED_PROGRESS_COMPONENT_CONSOLIDATION">
		{{ item.consolidationDays }} {{ labels().PUBLISHED_PROGRESS_COMPONENT_DAYS }}
	</ngb-progressbar>
	}
</ngb-progressbar-stacked>
} @else {
<span><b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_COMPLETED }}</b></span>
}
<hr class="my-5">
}
<div class="d-flex">
	<span class="d-flex align-items-center">
		<i class="material-icons text-primary" style="font-size: 3.5rem;">stop</i>
		<b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_LATENCY }}</b>
	</span>
	<span class="d-flex align-items-center ms-5">
		<i class="material-icons text-warning" style="font-size: 3.5rem;">stop</i>
		<b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_CORRECTION }}</b>
	</span>
	<span class="d-flex align-items-center ms-5">
		<i class="material-icons text-success" style="font-size: 3.5rem;">stop</i>
		<b>{{ labels().PUBLISHED_PROGRESS_COMPONENT_CONSOLIDATION }}</b>
	</span>
</div>